export class Channel {
    _id: string;
    id: string;
    name:string;
    category:{
        _id:string,
        id:string
    };
    technology:{
        _id:string,
        id:string
    };
    is_deleted: any;
    is_activated: any;
    notes:string;
    admin_notes: string;
}